export default {
  createdDate: {
    asc: 'createdDate_ASC',
    desc: 'createdDate_DESC',
  },
  organization: {
    asc: 'organization_ASC',
    desc: 'organization_DESC',
  },
  firstName: {
    asc: 'firstName_ASC',
    desc: 'firstName_DESC',
  },
  lastName: {
    asc: 'lastName_ASC',
    desc: 'lastName_DESC',
  },
  city: {
    asc: 'city_ASC',
    desc: 'city_DESC',
  },
  state: {
    asc: 'state_ASC',
    desc: 'state_DESC',
  },
};
